<template>
    <div class="content">
        <!-- Banner Carousel -->
        <section>
            <div class="content-box">
                <div class="text-center">
                    <img :src="responsiveImage" style="height: 100%; width: 100%;" class="img-fluid" id="home-image" />
                    <h1 style="font-size: 65px;color:black;font-weight: bolder;">1 BILLION</h1>
                    <p class="m-0 p-0" style="color: #001CAD;">{{ formattedDate }}</p>
                    <p class="m-0 p-0" style="color:#555555">Jackpot Estimate</p>
                </div>
                <br><br>

                <div style="background:url('/assets/bg_slider_home.png');background-repeat: no-repeat;background-size: 100% 100%"
                    id="wrap-slider-winning">

                    <h1 class="text-white p-0 m-0" style="font-weight: bolder">WINNING NUMBERS</h1>
                    <p class="text-white p-0 m-0">Latest EUROPE LOTTO Lottery Draw Results</p>

                    <router-link class="nav-link" :to="'/quickpick'">
                        <a class="btn-gold my-4 d-inline-block">all results</a>
                    </router-link>

                    <p v-if="resultsLoadError" class="text-warning small px-2 mb-0">
                        {{ resultsLoadError }}
                    </p>
                    <p v-else-if="resultsLoading" class="text-white small px-2 mb-2">Loading results…</p>

                    <swiper
                        v-if="results.length"
                        :key="resultsHydrateKey"
                        :slides-per-view="1.2"
                        :space-between="12"
                        class="mySwiper"
                    >
                        <swiper-slide v-for="(result, idx) in results" :key="`${result.id ?? idx}-${result.type}`">
                            <CardResultHome :data="result" />
                        </swiper-slide>
                    </swiper>
                </div>

                <br>

                <h1 style="font-weight: bolder;font-size: 25px;color:black">CLAIM YOUR BONUS</h1>
                <h2 style="color: #001CAD;font-size: 16px;margin-bottom: 0px;">CLAIM THE BONUS EVERY DAY</h2>
                <a class="btn-gold my-4 d-inline-block">See All Results</a>

                <div class="p-2">
                    <swiper :slides-per-view="1.2" :space-between="12" :centered-slides="false">
                        <swiper-slide>
                            <B_card />
                        </swiper-slide>
                        <swiper-slide>
                            <B_card />
                        </swiper-slide>
                        <swiper-slide>
                            <B_card />
                        </swiper-slide>
                    </swiper>
                </div>

                <div class="row">
                    <div class="col-md-9">

                    </div>
                </div>

            </div>

        </section>
    </div>
</template>


<script setup>
import { ref, onMounted, onBeforeUnmount } from 'vue'
import api from '@/axios'
import { asApiArray } from '@/utils/apiData'
import CardResultHome from './components/CardResultHome.vue'
import B_card from './components/B_card.vue'
import { Swiper, SwiperSlide } from 'swiper/vue'
import 'swiper/swiper-bundle.css'

const defaultImage = '/assets/home_image.png'
const mobileImage = '/assets/home_image_mobile.png' // <-- your mobile image
const responsiveImage = ref(defaultImage)

const results = ref([])
const resultsLoading = ref(true)
const resultsLoadError = ref('')
const resultsHydrateKey = ref(0)

const checkScreenSize = () => {
    responsiveImage.value = window.innerWidth <= 991 ? mobileImage : defaultImage
}

onBeforeUnmount(() => {
    window.removeEventListener('resize', checkScreenSize)
})
const formattedDate = ref('')

const updateFormattedDate = () => {
    const today = new Date()
    const dayName = today.toLocaleDateString('en-US', { weekday: 'long' }) // e.g., Friday
    const day = today.getDate() // e.g., 15
    const year = today.getFullYear() // e.g., 2024

    // Format output sesuai keinginan
    formattedDate.value = `${dayName}, ${day} ${year}` // Contoh: "Friday, 15 2024"
}

onMounted(() => {
    updateFormattedDate()
})

onMounted(async () => {
    checkScreenSize()
    window.addEventListener('resize', checkScreenSize)
    // Replace with real API call later

    resultsLoading.value = true
    resultsLoadError.value = ''
    try {
        const response = await api.get('/results/latest')
        const list = asApiArray(response.data)
        results.value = list
        resultsHydrateKey.value += 1
    } catch (error) {
        const msg =
            error?.response?.data?.message ||
            error?.message ||
            'Could not load results. Check API URL, CORS, and network.'
        resultsLoadError.value = String(msg)
        console.error('Error fetching results:', error)
    } finally {
        resultsLoading.value = false
    }

    // results.value = [
    //     {
    //         id: 145,
    //         type: '3d',
    //         result: '233',
    //         result2: '142',
    //         result3: '737',
    //         created_at: '2025-04-18 08:00:00',
    //         nextDrawTime: "2025-05-09 12:00:01"
    //     },
    //     {
    //         id: 147,
    //         type: '4d',
    //         result: '2587',
    //         result2: '8865',
    //         result3: '4030',
    //         created_at: '2025-05-02 12:00:01',
    //         nextDrawTime: "2025-05-09 12:00:01"
    //     },
    //     {
    //         id: 146,
    //         type: '5d',
    //         result: '92164',
    //         result2: '08792',
    //         result3: '18039',
    //         created_at: '2025-05-02 12:00:01',
    //         nextDrawTime: "2025-05-10 14:00:01"
    //     },

    // ]
})

</script>

<script>
export default {
    name: 'HomePage',
    components: {
        CardResultHome
        // OwlCarousel
    },
    data() {
        return {
            bannerOptions: {
                items: 1,
                autoplay: true,
                smartSpeed: 1000,
                loop: true,
                autoplayHoverPause: true,
                dots: true,
                responsive: {
                    0: { items: 1 },
                    480: { items: 1 },
                    768: { items: 1 }
                }
            },
            lotteryOptions: {
                items: 1,
                autoplay: false,
                smartSpeed: 1000,
                loop: true,
                dots: false,
                autoplayHoverPause: true,
                responsive: {
                    0: { items: 1 },
                    480: { items: 1 },
                    768: { items: 1 }
                }
            }
        };
    },
    methods: {
        nextLottery() {
            this.$refs.lotteryCarousel.next();
        },
        prevLottery() {
            this.$refs.lotteryCarousel.prev();
        }
    }
};
</script>

<style scoped>
.owl-carousel .owl-item img {
    display: inline;
}

#banner-items .owl-dots {
    margin-top: -30px;
    z-index: 100;
    position: relative;
}

#banner-items .owl-dots .owl-dot.active span {
    background: white !important;
}

#banner-items .owl-dots .owl-dot span {
    background: rgba(0, 0, 0, 0);
    border: 2px solid white;
}
</style>